module.exports = "/_next/static/images/a88552746489629fbdd44f55342ba443-rewards-smiles@1x.png.webp";